import { render, staticRenderFns } from "./AddressBookInput.vue?vue&type=template&id=2fcd2c72&scoped=true"
import script from "./AddressBookInput.vue?vue&type=script&lang=js"
export * from "./AddressBookInput.vue?vue&type=script&lang=js"
import style0 from "./AddressBookInput.vue?vue&type=style&index=0&id=2fcd2c72&prod&scoped=true&lang=css"
import style1 from "./AddressBookInput.vue?vue&type=style&index=1&id=2fcd2c72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcd2c72",
  null
  
)

export default component.exports